<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 3L3 3L3 5H5V3ZM19 7L21 7L21 13H19L19 9L9 9L9 19H13V21L7 21L7 7L19 7ZM7 3L9 3V5L7 5L7 3ZM5 7H3L3 9H5L5 7ZM3 11H5L5 13H3L3 11ZM5 15H3L3 17H5V15ZM11 3L13 3V5L11 5V3ZM17 3L15 3V5L17 5V3ZM15 17V15H21V17H19V19H17V21H15V17ZM19 19V21H21V19H19Z" fill="currentColor"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGDragNDrop',
};
</script>

<style scoped>

</style>